import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import { withLocalePrefix } from 'shared/utils/translation';
import { namesByRisk } from './selection';
import {
  BulkActionRow,
  QuickSelectButton,
  TierDot,
  TierLabel,
} from './styled_components';
import { Risk, ScopeFamily } from './types';

const t = withLocalePrefix('scope_tree');

const TIER_RISKS: Risk[] = ['view', 'warning', 'error'];

type Props = {
  families: ScopeFamily[];
  onSetScopes: (names: string[], checked: boolean) => void;
};

// Birch buttons stringify their children into aria-label, so per-tier
// accessible names ("Select all view permissions") need a custom button.
export default function BulkActionsToolbar({ families, onSetScopes }: Props) {
  return (
    <Stack spacing={1}>
      <Body>{t('bulk_actions.heading')}</Body>
      {TIER_RISKS.map((risk) => {
        const names = namesByRisk(families, [risk]);
        const tierLabel = t(`bulk_actions.tiers.${risk}`);
        const tierSuffix = t('bulk_actions.tier_permissions', {
          tier: tierLabel.toLowerCase(),
        });

        return (
          <BulkActionRow key={risk}>
            <TierDot $risk={risk} />
            <TierLabel>{tierLabel}</TierLabel>
            <QuickSelectButton
              type="button"
              aria-label={`${t('bulk_actions.select_all')} ${tierSuffix}`}
              onClick={() => onSetScopes(names, true)}
            >
              {t('bulk_actions.select_all')}
            </QuickSelectButton>
            <QuickSelectButton
              type="button"
              aria-label={`${t('bulk_actions.clear')} ${tierSuffix}`}
              onClick={() => onSetScopes(names, false)}
            >
              {t('bulk_actions.clear')}
            </QuickSelectButton>
          </BulkActionRow>
        );
      })}
    </Stack>
  );
}
